import { useMemo } from 'react'
import { useAppSelector, useDomainQueryParams } from 'app/hooks'
import { getCurrentSelectedDomain } from 'features/domains/utils'
import { selectedNavTopDomainIdSelector } from 'features/domains/selectors'

function useCurrentSelectedDomainId() {
  const domainQueryParams = useDomainQueryParams()
  const currentUserTopDomainId =
    useAppSelector(selectedNavTopDomainIdSelector) || null
  const domainId = useMemo(
    () => getCurrentSelectedDomain(currentUserTopDomainId, domainQueryParams),
    [currentUserTopDomainId, domainQueryParams]
  )

  return domainId
}

export default useCurrentSelectedDomainId
